import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import FeaturesSection from "@/components/FeaturesSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import AchievementsSection from "@/components/AchievementsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import CollaboratorSection from "@/components/CollaboratorSection";
import OffersSection from "@/components/OffersSection";
import FAQSection from "@/components/FAQSection";
import ContactSection from "@/components/ContactSection";
import BlogSection from "@/components/BlogSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <AboutSection />
      <ServicesSection />
      <AchievementsSection />
      <CollaboratorSection />
      <OffersSection />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection />
      <BlogSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
